import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { wheatonConfig } from "./data";

export default function WheatonPage() {
  return <CityPageTemplate config={wheatonConfig} />;
}